import React from 'react';
import TextFieldWithClear from 'components/TextFieldWithIcon/TextFieldWithIcon';
import classNames from 'classnames';
const styles = require('../styles.pcss');

interface FlagNameSectionProps {
  name: string;
  friendlyName: string;
  errorName: string;
  errorFriendlyName: string;
  onChangeName: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeFriendlyName: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onDeleteName: () => void;
  onDeleteFriendlyName: () => void;
}

const FlagNameSection: React.FC<FlagNameSectionProps> = ({
  name,
  friendlyName,
  errorName,
  errorFriendlyName,
  onChangeName,
  onChangeFriendlyName,
  onDeleteName,
  onDeleteFriendlyName,
}) => (
  <div className={classNames(styles.informationTitle, styles.addMarginTop)}>
    <h2>Flag Name</h2>
    <div className={classNames(styles.inputContainer, styles.inputContainerCreditCard)}>
      <div className={styles.inputWrapper}>
        <TextFieldWithClear
          helperText={errorName}
          fullWidth
          id="name"
          className={classNames(styles.textField)}
          label="Name"
          variant="outlined"
          margin="normal"
          value={name}
          onChange={onChangeName}
          error={!!errorName}
          onClear={onDeleteName}
        />
      </div>
      <div className={styles.inputWrapper}>
        <TextFieldWithClear
          fullWidth
          id="frname"
          className={classNames(styles.textField)}
          label="Friendly Name"
          variant="outlined"
          margin="normal"
          value={friendlyName}
          onChange={onChangeFriendlyName}
          error={!!errorFriendlyName}
          onClear={onDeleteFriendlyName}
        />
      </div>
    </div>
  </div>
);

export default FlagNameSection;
